import type { EntitlementsPermissionType } from '../../../services/entitlements-report';

export const ENTITLEMENTS_REPORT_QUERY_PARAMS = {
  organizations: 'organization',
  types: 'type',
  feedCodes: 'feed',
  startDate: 'startDate',
  ongoing: 'ongoing',
};

export const ENTITLEMENTS_REPORT_FILTER_QUERY_PARAMS = Object.values(ENTITLEMENTS_REPORT_QUERY_PARAMS);

export function getDataFeedEntitlementsReportUrl(feedId: string, permissionType: EntitlementsPermissionType): string {
  const searchParams = new URLSearchParams({
    [ENTITLEMENTS_REPORT_QUERY_PARAMS.types]: permissionType,
    [ENTITLEMENTS_REPORT_QUERY_PARAMS.feedCodes]: feedId,
  });

  return `/reports?${searchParams.toString()}#entitlements`;
}